
define('text!templates/widgets/dataGridCells/lDateCell.html',[],function () { return '<span data-bind="lDate: $data"></span>';});

